{
  "name": "fitogest",
  "version": "19.40.0",
  "license": "UNLICENSED",
  "type": "module",
  "scripts": {
    "compile": "node buildWithInput.mjs",
    "start": "ng serve Fitogest",
    "start-fichajes": "ng serve Fichajes",
    "build-fichajes": "ng build Fichajes  --base-href /fichajes/",
    "angular-update": "ng update @angular/core@19 @angular/cli@19 --allow-dirty --force",
    "lint": "ng lint",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:ci": "jest --runInBand",
    "e2e": "ng e2e",
    "bundle": "npm pack",
    "zip:support": "rm -f FitoGEST_support.zip && zip -r FitoGEST_support.zip buildWithInput.mjs angular.json package.json package-lock.json tsconfig.json eslint.config.js jest-global-mocks.ts setup-jest.ts ngsw-config.json workbox-config.js src projects docs tools templates backend -x 'node_modules/*' 'dist/*' '*.zip' 'backend/vendor/*' 'backend/**/vendor/*' 'backend/**/cache/*' 'backend/**/logs/*' 'backend/**/tmp/*' 'backend/composer.phar' 'backend/firmas/*' 'backend/upload/*' 'backend/**/upload/*' 'backend/**/uploads/*' 'backend/informes/**/*.xls' 'backend/informes/**/*.xlsx' 'backend/informes/**/*.docx' 'backend/informes/**/*.pdf' 'backend/informes/**/*.png' 'backend/informes/**/*.jpg' 'backend/informes_pyf/**/*.docx' 'backend/informes_pyf/**/*.png' 'backend/informes_pyf/**/*.jpg' 'src/assets/images/*' 'src/assets/icons/*' 'src/assets/**/*.pdf' 'src/assets/logo*' 'src/assets/logos_*/*'",
    "compodoc": "compodoc -p src/tsconfig.app.json -s",
    "ng": "ng",
    "validate:reactive-form-builder": "node tools/validate-reactive-form-builder.mjs",
    "validate:reactive-form-builder:full": "node tools/validate-reactive-form-builder.mjs --install",
    "validate:reactive-form-builder:lint": "node tools/validate-reactive-form-builder.mjs --lint --skip-build --skip-tests",
    "inventory:vinculated-fields": "node tools/inventory-vinculated-fields.mjs --markdown=docs/reactive-form-builder/vinculated-fields-inventory.md",
    "inventory:vinculated-fields:json": "node tools/inventory-vinculated-fields.mjs",
    "validate:tratamientos-control": "node tools/validate-tratamientos-control.mjs",
    "pack:reactive-form-builder": "npm run build:reactive-form-builder && npm pack ./dist/reactive-form-builder",
    "pack:reactive-form-builder:dry-run": "npm run build:reactive-form-builder -- --configuration development && npm pack ./dist/reactive-form-builder --dry-run",
    "build:reactive-form-builder": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && ng build reactive-form-builder && node tools/finalize-reactive-form-builder-package.mjs",
    "build:reactive-form-builder:development": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && ng build reactive-form-builder --configuration development && node tools/finalize-reactive-form-builder-package.mjs",
    "build:reactive-form-builder:production": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && ng build reactive-form-builder --configuration production && node tools/finalize-reactive-form-builder-package.mjs",
    "audit:reactive-form-builder:legacy": "node tools/audit-reactive-form-builder-legacy-imports.mjs",
    "verify:reactive-form-builder": "npm run audit:reactive-form-builder:legacy:strict && npm run audit:reactive-form-builder:public-api && npm run audit:reactive-form-builder:ci && npm run test:reactive-form-builder:contracts && npm run test:reactive-form-builder:playground && npm run build:reactive-form-builder:production && npm pack ./dist/reactive-form-builder --dry-run && npm run test:reactive-form-builder:package-smoke",
    "release:reactive-form-builder:local": "npm run verify:reactive-form-builder && npm pack ./dist/reactive-form-builder",
    "audit:reactive-form-builder:legacy:strict": "node tools/audit-reactive-form-builder-legacy-imports.mjs --strict-app-imports",
    "audit:reactive-form-builder:public-api": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && node tools/audit-reactive-form-builder-public-api.mjs",
    "test:reactive-form-builder:contracts": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && node tools/test-reactive-form-builder-contracts.mjs",
    "test:reactive-form-builder:playground": "node tools/check-reactive-form-builder-playground.mjs",
    "publish:reactive-form-builder": "node tools/release-reactive-form-builder.mjs",
    "publish:reactive-form-builder:dry-run": "node tools/release-reactive-form-builder.mjs --dry-run",
    "audit:reactive-form-builder:ci": "node tools/check-reactive-form-builder-ci-config.mjs",
    "test:reactive-form-builder:package-smoke": "node tools/smoke-test-reactive-form-builder-package.mjs",
    "test:reactive-form-builder:package-smoke:source": "node tools/clean-reactive-form-builder-source-entrypoints.mjs && node tools/smoke-test-reactive-form-builder-package.mjs --source-only",
    "ci:reactive-form-builder": "npm run verify:reactive-form-builder && npm run build"
  },
  "dependencies": {
    "@angular/animations": "19.1.0",
    "@angular/cdk": "19.1.0",
    "@angular/common": "19.1.0",
    "@angular/compiler": "19.1.0",
    "@angular/core": "19.1.0",
    "@angular/forms": "19.1.0",
    "@angular/localize": "19.1.0",
    "@angular/platform-browser": "19.1.0",
    "@angular/platform-browser-dynamic": "19.1.0",
    "@angular/pwa": "19.1.0",
    "@angular/router": "19.1.0",
    "@angular/service-worker": "19.1.0",
    "@babel/core": "7.26.0",
    "@fullcalendar/angular": "6.1.16",
    "@fullcalendar/core": "6.1.15",
    "@fullcalendar/daygrid": "6.1.15",
    "@fullcalendar/interaction": "6.1.15",
    "@fullcalendar/timegrid": "6.1.15",
    "@google/maps": "1.1.3",
    "@n8n/chat": "0.58.0",
    "@ng-bootstrap/ng-bootstrap": "18.0.0",
    "@ngx-env/builder": "^19.1.0",
    "@northpoint-labs/vector-tiles-google-maps": "1.1.0",
    "@popperjs/core": "2.11.8",
    "@primeng/themes": "19.0.6",
    "@primer/octicons": "19.12.0",
    "acorn": "8.14.0",
    "ajv": "8.17.1",
    "bootstrap": "5.3.3",
    "buffer": "6.0.3",
    "canvg": "^4.0.2",
    "chart.js": "4.4.6",
    "chartjs-plugin-zoom": "^2.2.0",
    "core-js": "3.39.0",
    "crypto-js": "4.2.0",
    "dexie": "4.0.9",
    "font-awesome": "4.7.0",
    "fullcalendar": "6.1.15",
    "html2canvas": "1.4.1",
    "html2pdf": "0.0.11",
    "html2pdf-fix-jspdf": "0.0.4",
    "html2pdf.js": "0.10.2",
    "jquery": "3.7.1",
    "jspdf": "^2.5.2",
    "jspdf-autotable": "^5.0.2",
    "jspdf-fix-png": "1.4.2",
    "moment": "2.30.1",
    "ngx-ui-tour-primeng": "1.0.0",
    "node-gyp": "10.2.0",
    "ora": "^8.0.1",
    "pdf-text-extract": "1.5.0",
    "pdf-to-text": "0.0.7",
    "pdfmake": "0.2.18",
    "primeicons": "7.0.0",
    "primeng": "19.0.6",
    "quill": "2.0.2",
    "rxjs": "7.8.1",
    "sass": "1.69.5",
    "signature_pad": "5.0.2",
    "stream": "0.0.3",
    "timers": "0.1.1",
    "tippy.js": "6.3.7",
    "ts-md5": "1.3.1",
    "util": "0.12.5",
    "xml2js": "0.6.2",
    "zone.js": "0.15.0",
    "@fitogest/reactive-form-builder": "file:projects/reactive-form-builder"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.1.0",
    "@angular/cli": "19.1.0",
    "@angular/compiler-cli": "19.1.0",
    "@angular/language-service": "19.1.0",
    "@compodoc/compodoc": "1.1.26",
    "@jest/globals": "29.7.0",
    "@tsconfig/strictest": "2.0.5",
    "@types/eslint-config-prettier": "^6.11.3",
    "@types/jest": "29.5.14",
    "@types/jquery": "3.5.31",
    "@types/pdfmake": "0.2.11",
    "@types/primer__octicons": "19.11.0",
    "@types/xml2js": "0.4.14",
    "angular-eslint": "18.1.0",
    "eslint": "9.14.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-html": "8.1.2",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-promise": "7.1.0",
    "globals": "15.12.0",
    "jest": "29.7.0",
    "jest-preset-angular": "14.5.3",
    "prettier": "^3.7.4",
    "process": "0.11.10",
    "protractor": "7.0.0",
    "sharp": "0.33.5",
    "ts-node": "10.9.2",
    "ts-string-literal-enum-plugin": "0.0.3",
    "typescript": "5.7.3",
    "typescript-eslint": "8.37.0",
    "typescript-todo-or-die-plugin": "0.6.0",
    "ng-packagr": "^19.0.0"
  },
  "engines": {
    "node": ">=18.19.0",
    "npm": ">=10.2.4"
  },
  "jest": {
    "preset": "jest-preset-angular",
    "setupFilesAfterEnv": [
      "./setup-jest.ts"
    ],
    "testEnvironment": "jsdom",
    "transform": {
      "^.+\\.(ts|js|html)$": [
        "jest-preset-angular",
        {
          "tsconfig": "src/tsconfig.spec.json",
          "stringifyContentPathRegex": "\\.html$"
        }
      ]
    },
    "moduleNameMapper": {
      "^src/(.*)$": "<rootDir>/src/$1"
    }
  },
  "private": true,
  "bundleDependencies": [
    "@angular/animations",
    "@angular/cdk",
    "@angular/common",
    "@angular/compiler",
    "@angular/core",
    "@angular/forms",
    "@angular/localize",
    "@angular/platform-browser",
    "@angular/platform-browser-dynamic",
    "@angular/pwa",
    "@angular/router",
    "@angular/service-worker",
    "@babel/core",
    "@fullcalendar/angular",
    "@fullcalendar/core",
    "@fullcalendar/daygrid",
    "@fullcalendar/interaction",
    "@fullcalendar/timegrid",
    "@google/maps",
    "@n8n/chat",
    "@ng-bootstrap/ng-bootstrap",
    "@northpoint-labs/vector-tiles-google-maps",
    "@popperjs/core",
    "acorn",
    "ajv",
    "bootstrap",
    "buffer",
    "chart.js",
    "core-js",
    "crypto-js",
    "dexie",
    "font-awesome",
    "fullcalendar",
    "html2canvas",
    "html2pdf",
    "html2pdf-fix-jspdf",
    "html2pdf.js",
    "jspdf",
    "jspdf-fix-png",
    "moment",
    "node-gyp",
    "sass",
    "@primer/octicons",
    "ora",
    "pdf-text-extract",
    "pdf-to-text",
    "primeicons",
    "primeng",
    "ngx-ui-tour-primeng",
    "quill",
    "rxjs",
    "signature_pad",
    "stream",
    "timers",
    "tippy.js",
    "ts-md5",
    "util",
    "xml2js",
    "zone.js"
  ],
  "workspaces": [
    "projects/reactive-form-builder"
  ]
}
